import React, { Component } from "react";
import { Divider, Row, Layout, Button } from "antd";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import BestCatsTable from "../../table/BestCatsTable";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  VKShareButton,
  FacebookIcon,
  RedditIcon,
  TwitterIcon,
  VKIcon,
} from "react-share";
import VenatusAd from "../../ads/VenatusAd";
import VenatusAdWithPlaceholder from "../../ads/VenatusAdWithPlaceholder";
import {
  VENATUS_DESKTOP_LEADERBOARD,
  VENATUS_MOBILE_LEADERBOARD,
  VENATUS_MOBILE_INCONTENT,
  VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL,
  VENATUS_RICH_MEDIA,
} from "../../utilities/constants";

const shareURL = "https://mygamatoto.com/best-cats-for-health";

const { Content } = Layout;
// const convertBasedOnLevel = require("../../table/calc-stats");

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

class Health extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewportWidth: 0,
      compareCatsLevels: 30,
    };
  }
  componentDidMount() {
    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGA();
    // logPageView();

    document.title = "Best Cats for Health | Battle Cats Wiki for Cat Stats";
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 636) {
      adjustViewport = 22;
    } else if (window.innerWidth < 948) {
      adjustViewport = 34;
    } else {
      adjustViewport = 46;
    }

    this.setState({
      viewportWidth: window.innerWidth - adjustViewport,
    });
  }, this.props.applyViewportChange);

  showModal = () => {
    this.setState({ isModalVisible: true });
  };

  handleCancel = () => {
    this.setState({ isModalVisible: false });
  };

  render() {
    const bestCats = [
      {
        key: "535-2",
        name: "Hades the Deathdealer",
        number: "535-2",
        form: "Evolved",
        rarity: "Uber Super Rare",
        level: 1,
        health: 62500,
        damage: 2100,
        range: 250,
        kb: 2,
        speed: 8,
        dps: 1032,
        target: "Area",
        tba: "2.03",
        anim: "1.50",
        spawn: "131.53",
        cost: 4425,
        ability:
          "u1General Abilitiesu2: b1Multi-hit attackb2 (Attacks thrice consecutively)\nu1Not affected byu2: b1Warpb2, b1Toxicb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "582-1",
        name: "Stone Cat",
        number: "582-1",
        form: "Normal",
        rarity: "Rare",
        level: 1,
        health: 50000,
        damage: 700,
        range: 140,
        kb: 1,
        speed: 84,
        dps: 512,
        target: "Single",
        tba: "1.37",
        anim: "0.03",
        spawn: "5.20",
        cost: 360,
        ability:
          "u1General Abilitiesu2: b1Attack Onceb2 (Attacks a single time, then disappears from the battlefield)\nu1Not affected byu2: b1Weakenb2, b1Freezeb2, b1Slowb2, b1Knockbackb2, b1Warpb2, b1Waveb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "451-1",
        name: "High Lord Babel",
        number: "451-1",
        form: "Normal",
        rarity: "Legendary Rare",
        level: 1,
        health: 37500,
        damage: 12500,
        range: 390,
        kb: 2,
        speed: 8,
        dps: 1042,
        target: "Area",
        tba: "12.00",
        anim: "3.77",
        spawn: "158.20",
        cost: 6750,
        ability:
          "u1Against red, floatingu2: b1Insanely Toughb2 (only takes 0.17x damage)\nu1Not affected byu2: b1Freezeb2, b1Slowb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "560-1",
        name: "Hell Warden Emma",
        number: "560-1",
        form: "Normal",
        rarity: "Uber Super Rare",
        level: 1,
        health: 37500,
        damage: 3000,
        range: 200,
        kb: 10,
        speed: 30,
        dps: 565,
        target: "Area",
        tba: "5.30",
        anim: "3.27",
        spawn: "124.87",
        cost: 4350,
        ability:
          "u1Against allu2: b1Weakenb2 (20% chance to weaken by 50% for 2.0s) \nu1General Abilitiesu2: b1Wave Shieldb2 (Protects units behind them from shockwaves) b1Long Distanceb2 (Effective range 350~-600) b1Multi-hit attackb2 (Attacks thrice consecutively)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "135-3",
        name: "King Gamereon",
        number: "135-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 36250,
        damage: 5625,
        range: 380,
        kb: 3,
        speed: 5,
        dps: 848,
        target: "Area",
        tba: "6.63",
        anim: "2.00",
        spawn: "164.87",
        cost: 4875,
        ability:
          "u1Against black, angelu2: b1Resistantb2 (only takes 0.25x damage)\nu1Not affected byu2: b1Weakenb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "178-3",
        name: "God-Emperor Dioramos",
        number: "178-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 34000,
        damage: 8750,
        range: 410,
        kb: 2,
        speed: 4,
        dps: 928,
        target: "Area",
        tba: "9.43",
        anim: "3.47",
        spawn: "156.87",
        cost: 6600,
        ability:
          "u1Against angelu2: b1Slowb2 (100% chance to slow for 4.0s) b1Knockbackb2 (100% chance of knockback) \nu1General Abilitiesu2: b1Barrier Breakerb2 (100% chance of breaking enemy barriers)\nu1Not affected byu2: b1Slowb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "107-3",
        name: "Divine Kai",
        number: "107-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 28500,
        damage: 17475,
        range: 175,
        kb: 2,
        speed: 16,
        dps: 1665,
        target: "Area",
        tba: "10.50",
        anim: "2.53",
        spawn: "71.53",
        cost: 3990,
        ability:
          "u1Against floatingu2: b1Resistantb2 (only takes 0.25x damage) \nu1General Abilitiesu2: b1Surviveb2 (100% chance to survive a lethal strike)\nu1Not affected byu2: b1Knockbackb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "482-1",
        name: "Doktor Heaven",
        number: "482-1",
        form: "Normal",
        rarity: "Legendary Rare",
        level: 1,
        health: 27500,
        damage: 6775,
        range: 400,
        kb: 3,
        speed: 8,
        dps: 1452,
        target: "Area",
        tba: "4.67",
        anim: "2.03",
        spawn: "168.20",
        cost: 5400,
        ability:
          "u1Against black, alienu2: b1Insanely Toughb2 (only takes 0.17x damage)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "227-3",
        name: "Mad Doctor Klay",
        number: "227-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 23250,
        damage: 24038,
        range: 430,
        kb: 2,
        speed: 8,
        dps: 3018,
        target: "Area",
        tba: "7.97",
        anim: "2.33",
        spawn: "164.87",
        cost: 6135,
        ability:
          "u1Against alienu2: u1Attacks onlyu2b1 alienb2\nu1Not affected byu2: b1Weakenb2, b1Freezeb2, b1Slowb2, b1Knockbackb2",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
      {
        key: "044-3",
        name: "Cat Machine Mk 3",
        number: "044-3",
        form: "True",
        rarity: "Uber Super Rare",
        level: 1,
        health: 22500,
        damage: 13888,
        range: 190,
        kb: 1,
        speed: 15,
        dps: 1560,
        target: "Area",
        tba: "8.90",
        anim: "5.60",
        spawn: "64.87",
        cost: 3600,
        ability:
          "u1Against red, alienu2: b1Resistantb2 (only takes 0.25x damage) \nu1General Abilitiesu2: b1Wave Shieldb2 (Protects units behind them from shockwaves)",
        iscrazed: null,
        level2: this.state.compareCatsLevels,
      },
    ];

    // console.log(typeof(bestCats))

    return (
      <div>
        <div className="pagetitle">
          <h1 style={{ padding: "10px 0 0 0", marginBottom: "6px" }}>
            Best Cats
          </h1>
          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>
        <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
          <Content className="flexible-width">
            <Row style={{ padding: "16px 0 0 0" }}>
              <div>
                {this.state.viewportWidth > 1024 ? (
                  <VenatusAdWithPlaceholder
                    placementId={VENATUS_DESKTOP_LEADERBOARD}
                  />
                ) : (
                  ""
                )}
                <h2 style={{ marginTop: "12px", fontSize: "24px" }}>
                  Best Cats for Health
                </h2>
                <p></p>
                <div>
                  What are the best cats in the Battle Cats with the highest
                  health? Which ones have the top health to tank the most
                  damage?
                </div>
                <p></p>
                <div>
                  Comparing the stats for the top 10 cats gives us the list
                  below.
                </div>
                <p></p>
                <i>Last updated: 8 March 2021</i>
              </div>
            </Row>

            <Row style={{ margin: "16px 0 0 0" }}>
              <FacebookShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <FacebookIcon size={32} round />
              </FacebookShareButton>
              <TwitterShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Best Cats for Health"
                style={{ marginRight: "0.25rem" }}
              >
                <TwitterIcon size={32} round />
              </TwitterShareButton>
              <RedditShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                style={{ marginRight: "0.25rem" }}
              >
                <RedditIcon size={32} round />
              </RedditShareButton>
              <VKShareButton
                url={"http://mygamatoto.com" + window.location.pathname}
                title="MyGamatoto - Best Cats for Health"
                style={{ marginRight: "0.25rem" }}
              >
                <VKIcon size={32} round />
              </VKShareButton>
            </Row>
            {this.state.viewportWidth > 1024 ? (
              ""
            ) : (
              <div style={{ margin: "10px 0 0 0" }}>
                <div
                  class="vm-placement"
                  id="vm-av"
                  data-format="isvideo"
                ></div>
              </div>
            )}
            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  10.
                </Divider>
                <div
                  style={{
                    backgroundColor: "#ffa50038",
                    padding: "16px 8px",
                    margin: "20px 0",
                  }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[9].number +
                      ".png"
                    }
                    alt={bestCats[9].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[9].number.slice(0, 3) +
                          "/" +
                          bestCats[9].name
                        }
                      >
                        {bestCats[9].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  The next generation of battle tech, MS:RX-Ω has slipped into
                  the hands of the Cat Army! Resists Red/Alien attacks, immune
                  to Waves.
                  <p></p>
                  <b>Pros: </b>Considered cheap amongst Ubers, with a decent
                  respawn time and good attack power. Its wave shield grants
                  extra protection to all your cats!
                  <p></p>
                  <b>Cons: </b>Long attack animation means it may sometimes miss
                  if the frontline enemies have been knocked back.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[9].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Cat Machine Mk 3"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}

            {/* <div id="waldo-tag-14680"></div> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  9.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[8].number +
                      ".png"
                    }
                    alt={bestCats[8].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[8].number.slice(0, 3) +
                          "/" +
                          bestCats[8].name
                        }
                      >
                        {bestCats[8].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Picked up an online degree in occult anatomy. 1st attempt at a
                  soul transplant: GREAT SUCCESS!(?) Delivers extreme damage,
                  but only to Aliens/bases!
                  <p></p>
                  <b>Pros: </b>Also on the{" "}
                  <Link to={"/best-cats-for-attack"}>Best Cats for Attack</Link>{" "}
                  list.
                  <p></p>
                  <b>Cons: </b>This true form grants the highest health, but
                  alas it can only attack aliens. Very expensive too, but cost
                  may be less of an issue on alien stages.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[8].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Mad Doctor Klay"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  8.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[7].number +
                      ".png"
                    }
                    alt={bestCats[7].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[7].number.slice(0, 3) +
                          "/" +
                          bestCats[7].name
                        }
                      >
                        {bestCats[7].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A fearsome scientist obsessed with using
                  extra- dimensional power to instantly sublimate matter. Tough
                  vs Black &amp; Aliens with Area Attacks.
                  <p></p>
                  <b>Pros: </b>Can choose for her to be insanely tough or deal
                  insane damage, between her normal and evolved forms. Pretty
                  versatile.
                  <p></p>
                  <b>Cons: </b>Other than its health and damage, nothing really
                  stands out. Mid-range, time between attacks is alright, quite
                  pricey, and slow recharging time.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[7].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Doktor Heaven"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  7.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[6].number +
                      ".png"
                    }
                    alt={bestCats[6].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[6].number.slice(0, 3) +
                          "/" +
                          bestCats[6].name
                        }
                      >
                        {bestCats[6].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  If any cute guy is your type, is that really a type? Always
                  travels via her trusty Boarborg (Area Atk) Reduced damage from
                  Flying, Survives Once.
                  <p></p>
                  <b>Pros: </b>Great meatshield, especially when used in the
                  Pork on Rice Defense Up (Sm) combo. Also on the{" "}
                  <Link to={"/best-cats-for-attack"}>Best Cats for Attack</Link>{" "}
                  list.
                  <p></p>
                  <b>Cons: </b>Survive ability is pretty useless given her long
                  time between attacks, but there's nothing else to nitpick
                  about her.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[6].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Divine Kai"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  6.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[5].number +
                      ".png"
                    }
                    alt={bestCats[5].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[5].number.slice(0, 3) +
                          "/" +
                          bestCats[5].name
                        }
                      >
                        {bestCats[5].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Brutal attacks powered by hate - a family tradition of
                  mercilessness. 100% Barrier break, plus Knockback &amp; Slow
                  vs Angels (Area Atk)
                  <p></p>
                  <b>Pros: </b>Good for stalling, with extra stalling
                  effectiveness against angels.
                  <p></p>
                  <b>Cons: </b>So slow that your hair will turn white before he
                  reaches your enemy, like a tankier Bahamut but with less
                  damage and way more expensive.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[5].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "God-Emperor Dioramos"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  5.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[4].number +
                      ".png"
                    }
                    alt={bestCats[4].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[4].number.slice(0, 3) +
                          "/" +
                          bestCats[4].name
                        }
                      >
                        {bestCats[4].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  To impress his crush at the secret lab, made some bold new
                  fashion choices (and bought donuts). Resistant to Black/Angel
                  attacks.
                  <p></p>
                  <b>Pros: </b>Strengths are similar to High Lord Babel, just
                  against Black/Angel and slightly less effectively.
                  <p></p>
                  <b>Cons: </b>Don't be over-reliant on it, especially in late
                  game where the enemies are stronger and its slow respawn
                  outweighs its strengths. Not too sure about its fashion
                  choices either.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[4].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "King Gamereon"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  4.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[3].number +
                      ".png"
                    }
                    alt={bestCats[3].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[3].number.slice(0, 3) +
                          "/" +
                          bestCats[3].name
                        }
                      >
                        {bestCats[3].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Hunter of evil souls trying to escape their eternal
                  punishment. Back to the pit with you! Omnistrikes might
                  Weaken. Immune to Waves.
                  <p></p>
                  <b>Pros: </b>Wave shield with many knockbacks. Will last
                  longer and protect for longer!
                  <p></p>
                  <b>Cons: </b>When being knocked back, some waves will slip
                  past her. Doesn't offer 100% protection.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[3].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Hell Warden Emma"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "16px 0 8px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  3.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[2].number +
                      ".png"
                    }
                    alt={bestCats[2].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[2].number.slice(0, 3) +
                          "/" +
                          bestCats[2].name
                        }
                      >
                        {bestCats[2].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  The original dragon who became one with the heavenly castle
                  that controls the mortal realms. Insanely tough vs
                  Red/Floating (Area Attack)
                  <p></p>
                  <b>Pros: </b>Great for stalling against Red/Floating, and can
                  deal some damage to ranged enemies.
                  <p></p>
                  <b>Cons: </b>Slow respawn and speed, so once it's dead, that's
                  it. It's also mid-range, so has a high chance of missing the
                  short-ranged enemies. Use him selectively.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[2].damage}  */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "High Lord Babel"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row style={{ padding: "16px 0 0px 0" }}>
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  2.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[1].number +
                      ".png"
                    }
                    alt={bestCats[1].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[1].number.slice(0, 3) +
                          "/" +
                          bestCats[1].name
                        }
                      >
                        {bestCats[1].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>A mineral-based lifeform recovered by
                  GAMATOTO from deep beneath the earth. Finally made useful
                  after eight years of research. Attacks exactly once.
                  <p></p>
                  <b>Pros: </b>Behaves like an iron wall for 1.37s. Nothing will
                  get past it.
                  <p></p>
                  <b>Cons: </b>Needs to be timed well.
                  {/* <p></p>
                  <b>Damage: </b>{bestCats[1].damage} */}
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Stone Cat"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "0px 0 0px 0" }}>
              <Row style={{ padding: "0px 0 16px 0" }}>
                <Divider orientation="left" style={{ fontSize: "24px" }}>
                  1.
                </Divider>
                <div
                  style={{ backgroundColor: "#ffa50038", padding: "15px 8px" }}
                >
                  <img
                    src={
                      "https://onestoppress.com/images/" +
                      bestCats[0].number +
                      ".png"
                    }
                    alt={bestCats[0].name}
                    style={{ float: "left", paddingRight: "8px" }}
                  />
                  <div style={{ padding: "3.5px 0px 0.5px 0px" }}>
                    <h4>
                      &nbsp;
                      <Link
                        to={
                          "/catinfo/" +
                          bestCats[0].number.slice(0, 3) +
                          "/" +
                          bestCats[0].name
                        }
                      >
                        {bestCats[0].name}
                      </Link>
                    </h4>
                  </div>
                </div>
                <p></p>
                <div>
                  <b>Description: </b>
                  Ruler of the underworld who reaps the spirits of sinners,
                  bringing them to their ultimate fate. Immune to Toxic &amp;
                  Warp (Area Attack)
                  <p></p>
                  <b>Pros: </b>Very frequent attacks. Great for stages with many
                  enemy types, especially those with pushers.
                  <p></p>
                  <b>Cons: </b>Slow respawn.
                </div>
              </Row>
              <BestCatsTable
                selectedCats={bestCats.filter(
                  (item) => item.name === "Hades the Deathdealer"
                )}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            {/* <InPageAdComponent
              dataAdClient="ca-pub-1920730948516638"
              dataAdSlot="6681079332"
            /> */}
            <div style={{ paddingTop: "1em" }} />
            {this.state.viewportWidth > 1024 ? (
              <span>
                <VenatusAdWithPlaceholder
                  placementId={VENATUS_DESKTOP_LEADERBOARD}
                />
              </span>
            ) : (
              <VenatusAdWithPlaceholder
                placementId={VENATUS_MOBILE_INCONTENT}
              />
            )}

            <Row style={{ padding: "6px 0 6px 0" }}>
              <Divider />
              <h3>Compare all 10 cats below</h3>
              <BestCatsTable
                selectedCats={bestCats}
                viewportHeight={this.state.viewportHeight}
              />
            </Row>

            <Row
              style={{
                padding: "24px 20px 18px 20px",
                backgroundColor: "#ffa50038",
                textAlign: "center",
                margin: "0 0 8px 0",
              }}
            >
              <div style={{ fontSize: "16px" }}>
                Want to compare the stats of any cat in The Battle Cats?
              </div>
              <Divider
                style={{ backgroundColor: "orange", marginTop: "12px" }}
              ></Divider>
              <Button href="/comparecats" size="large">
                Compare more cats
              </Button>
            </Row>
          </Content>
        </Layout>
        {this.state.viewportWidth > 1024 ? (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA_WITH_STICKY_VERTICAL}
              style={{ display: "none" }}
            />
          </div>
        ) : (
          <div>
            <VenatusAd
              placementId={VENATUS_RICH_MEDIA}
              style={{ display: "none" }}
            />
          </div>
        )}
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="6015153906"
        ></HorizontalAdPopup> */}
        {/* <div id="waldo-tag-14678"></div> */}
      </div>
    );
  }
}

export default Health;

Health.propTypes = {
  applyViewportChange: PropTypes.number,
};

Health.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components/content/bestcats/Health.js